export default "__VITE_ASSET__d27df956__"